import { usePal, PalHead } from "./PalUI";

const PalNextSteps = () => {
  const { c, brand, ink, muted, hair } = usePal();
  const n = c.nextSteps;
  return (
    <section aria-label={n.eyebrow} data-testid="pal-next-steps">
      <PalHead eyebrow={n.eyebrow} title={n.title} accentLine={n.accentLine} lead={n.lead} />
      <ol className={`mt-10 pt-8 border-t grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8 ${hair}`}>
        {n.outcomes.map((o, i) => (
          <li key={o.title} className="flex gap-4" data-testid={`pal-next-${i}`}>
            <span className="text-[28px] font-semibold tabular-nums leading-none" style={{ color: brand }}>{i + 1}</span>
            <div>
              <h3 className={`text-[20px] font-semibold tracking-tight ${ink}`}>{o.title}</h3>
              <p className={`mt-1.5 text-[15px] leading-relaxed ${muted}`}>{o.desc}</p>
            </div>
          </li>
        ))}
      </ol>
      <p className={`mt-14 text-[26px] font-semibold tracking-tight ${ink}`} data-testid="pal-closing">{n.closing}</p>
    </section>
  );
};

export default PalNextSteps;
